import { createApiRequestType } from '@ackee/redux-utils';
import { ACTION_PREFIX } from 'modules/order/modules/order-create/constants';

const apiRequestType = createApiRequestType({ modulePrefix: ACTION_PREFIX });
export const csvImport = apiRequestType({ typePrefix: 'CSV_IMPORT_' });
